<div id="sustainability-dashboard">
  <div class="header-section">
    <div class="header-top">
      <div>
        <p class="header-title">Sustainability Dashboard</p>
        <p class="header-description">You can view graphs and reports from different aspects of your contracts</p>
      </div>
      <div class="enterprise-selection-container">
        <div class="enterprise-selection">
          <span class="enterprise-selection-label">{{ 'doktar_app.home.selected_enterprise' | translate }}</span>
          <p-select
            [options]="userEnterprises"
            [(ngModel)]="selectedEnterprise"
            optionLabel="name"
            (onChange)="onSelectEnterpriseChange($event.value)">
            <ng-template #selectedItem let-selectedOption>
              <div class="selected-enterprise">
                <div class="enterprise-name-w-icon">
                  <i class="ph-fill ph-handshake"></i>
                  <span>{{ selectedOption.name }}</span>
                </div>
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>
    </div>
  </div>
  <div class="row contracts-row">
    <span class="contracts-label">{{ 'doktar_app.account.enterprises.contracts' | translate }}</span>
    <div class="col-12 col-md-6 col-lg-3 contracts-controls">
      <p-select
        id="sustainability-dashboard-contracts-select"
        name="contracts"
        [options]="contractOptions"
        [(ngModel)]="selectedContractId"
        optionLabel="contractName"
        optionValue="contractId"
        placeholder="Select a contract"
        (onChange)="onSelectContract()" />
      <button class="refresh-btn" (click)="onRefresh()" [disabled]="dataLoading$ | async">
        @if (dataLoading$ | async) {
          <i class="pi pi-spin pi-spinner-dotted"></i>
        } @else {
          <i class="ph ph-arrows-clockwise"></i>
        }
      </button>
      <!-- <div class="filter-item filter-tool" (click)="onOpenFilterModal()">
        <i class="ph-fill ph-sliders-horizontal"></i>
        <span>{{ 'doktar_app.common.filter' | translate }}</span>
      </div> -->
    </div>
  </div>

  <div class="tabs pb-3">
    <div class="d-flex gap-4">
      @for (tab of tabOptions; track tab.value) {
        @if (tab.show) {
          <span class="tab-item" [class.active]="selectedTab === tab.value" (click)="onSelectTab(tab.value)">
            {{ tab.label }}
          </span>
        }
      }
    </div>
  </div>

  <router-outlet />
</div>
